<div class="info-item-container">
  <div class="muted_text small_text m_b-1">{{title}}</div>
  <div class="body_text">
    <ng-content></ng-content>
  </div>
</div>
